import { getTableColumn, TableColumn } from '@shared/UI';
import { useClientDetailsTable } from './BuySellAdjustmentTableProvider';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';
import { BiCaretDown, BiCaretUp } from 'react-icons/bi';

export function getTransactionsTableColumns(): TableColumn<any>[] {
    const { desc, sortFieldName, arrayWithLogos } = useClientDetailsTable();

    const columns: TableColumn<any>[] = [
        getTableColumn({
            title: 'Ticker',
            flex: 0.12,
            formatter: (_, row) => {
                return (
                    <div className='buy-sell-security'>
                        {/* <div className='portfolio__item-icon'>
                            {!!arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link ? (
                                <img
                                    className='positions-table-cell__logos'
                                    src={arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link}
                                    alt='logo'
                                />
                            ) : (
                                <div className='positions-table-cell__logos placeholder' />
                            )}
                        </div> */}
                        <div className='portfolio__item-details'>
                            <div className='buy-sell-symbol'>{row.symbol}</div>
                        </div>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'currentValue',
            title: 'Current Value',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return <div className='grey-text-buy'>${Math.abs(row.currentValue).toFixed(2)}</div>;
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Current Value'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'rebalancedValue',
            title: 'Rebalanced Value',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return <div className='grey-text-buy'>${Math.abs(row.rebalancedValue).toFixed(2)}</div>; // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Rebalanced Value'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'gainLoss',
            title: 'Gain/Loss',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return (
                    <>
                        <span style={{ color: row.gainLoss < 0 ? '#EB3F3C' : '#5ECF82' }}>
                            ${Math.abs(row.gainLoss).toFixed(2)}
                        </span>
                    </>
                );
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Gain/Loss'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'cashImpact',
            title: 'Cash',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return (
                    <div className='grey-text-buy'>
                        {' '}
                        {row.symbol !== 'Cash' ? (
                            <>
                                {row.cashImpact > 0 ? 'Created:' : 'Required:'} $
                                {Math.abs(row.cashImpact).toFixed(2)}{' '}
                            </>
                        ) : (
                            <>
                                {row.cashImpact < 0 ? 'Created:' : 'Required:'} $
                                {Math.abs(row.cashImpact).toFixed(2)}{' '}
                            </>
                        )}
                    </div>
                ); // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Cash'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'quantityChange',
            title: 'Share to Buy/Sell',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return (
                    <div className='grey-text-buy'>
                        {' '}
                        <div className='bold-black-text'>{row.quantityChange < 0 ? 'Sell ' : 'Buy '} </div>
                        {Math.abs(row.quantityChange).toFixed(2)} Shares
                    </div>
                ); // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Share to Buy/Sell'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),
    ];

    return columns;
}
